import { render, staticRenderFns } from "./studytasks.vue?vue&type=template&id=d10fb714"
import script from "./studytasks.ts?vue&type=script&lang=js&external"
export * from "./studytasks.ts?vue&type=script&lang=js&external"
import style0 from "./studytasks.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports